(function () {
    'use strict';

    var gettext = angular.identity;

    angular
        .module('app.shared')
        .enumeration('managementGroups', {
            GolfCanada: { displayName: gettext('Golf Canada'), logo: '/images/ON.png', logoSmall: '/images/handicap-card/ON.png', imgHandicapCard: '/images/handicap-card/DigitalGCMemberCard_ON.png' },
            AlbertaGolf: { displayName: gettext('Alberta Golf'), logo: '/images/AB.png', logoSmall: '/images/handicap-card/AB.png', imgHandicapCard: '/images/handicap-card/DigitalGCMemberCard_AB.png' },
            BritishColumbiaGolf: { displayName: gettext('British Columbia Golf'), logo: '/images/BC.png', logoSmall: '/images/handicap-card/BC.png', imgHandicapCard: '/images/handicap-card/DigitalGCMemberCard_BC.png', },
            GolfManitoba: { displayName: gettext('Golf Manitoba'), logo: '/images/MB.png', logoSmall: '/images/handicap-card/MB.png', imgHandicapCard: '/images/handicap-card/DigitalGCMemberCard_MB.png' },
            NewBrunswickGolfAssociation: { displayName: gettext('New Brunswick Golf Association'), logo: '/images/NB.png', logoSmall: '/images/handicap-card/NB.png', imgHandicapCard: '/images/handicap-card/DigitalGCMemberCard_NB.png' },
            GolfNewfoundlandLabrador: { displayName: gettext('Golf Newfoundland Labrador'), logo: '/images/NL.png', logoSmall: '/images/handicap-card/NL.png', imgHandicapCard: '/images/handicap-card/DigitalGCMemberCard_NL.png' },
            NovaScotiaGolfAssociation: { displayName: gettext('Nova Scotia Golf Association'), logo: '/images/NS.png', logoSmall: '/images/handicap-card/NS.png', imgHandicapCard: '/images/handicap-card/DigitalGCMemberCard_NS.png' },
            GolfAssociationOfOntario: { displayName: gettext('Golf Association of Ontario'), logo: '/images/ON.png', logoSmall: '/images/handicap-card/ON.png', imgHandicapCard: '/images/handicap-card/DigitalGCMemberCard_ON.png' },
            PEIGolfAssociation: { displayName: gettext('PEI Golf Association'), logo: '/images/PE.png', logoSmall: '/images/handicap-card/PE.png', imgHandicapCard: '/images/handicap-card/DigitalGCMemberCard_PE.png' },
            GolfQuebec: { displayName: gettext('Golf Québec'), logo: '/images/QC.png', logoSmall: '/images/handicap-card/QC.png', imgHandicapCard: '/images/handicap-card/DigitalGCMemberCard_QC.png' },
            GolfSaskatchewan: { displayName: gettext('Golf Saskatchewan'), logo: '/images/SK.png', logoSmall: '/images/handicap-card/SK.png', imgHandicapCard: '/images/handicap-card/DigitalGCMemberCard_SK.png' }
        })
        .constant('memberLookupPageSize', 100)
        .constant('memberLookupDebounce', 400)
        .enumeration('nationalAssociation', {
            RCGA: 'RCGA',
            USGA: 'USGA'
        })
        .enumeration('countryCodes', {
            CA: 'CA',
            US: 'US'
        })
        .constant('regions', [
            { region: 'AB', country: 'CA', name: gettext('Alberta') },
            { region: 'BC', country: 'CA', name: gettext('British Columbia') },
            { region: 'MB', country: 'CA', name: gettext('Manitoba') },
            { region: 'NB', country: 'CA', name: gettext('New Brunswick') },
            { region: 'NL', country: 'CA', name: gettext('Newfoundland and Labrador') },
            { region: 'NT', country: 'CA', name: gettext('Northwest Territories') },
            { region: 'NS', country: 'CA', name: gettext('Nova Scotia') },
            { region: 'NU', country: 'CA', name: gettext('Nunavut') },
            { region: 'ON', country: 'CA', name: gettext('Ontario') },
            { region: 'PE', country: 'CA', name: gettext('Prince Edward Island') },
            { region: 'QC', country: 'CA', name: gettext('Québec') },
            { region: 'SK', country: 'CA', name: gettext('Saskatchewan') },
            { region: 'YT', country: 'CA', name: gettext('Yukon') },
            { region: 'AL', country: 'US', name: gettext('Alabama') },
            { region: 'AK', country: 'US', name: gettext('Alaska') },
            { region: 'AZ', country: 'US', name: gettext('Arizona') },
            { region: 'AR', country: 'US', name: gettext('Arkansas') },
            { region: 'CA', country: 'US', name: gettext('California') },
            { region: 'CO', country: 'US', name: gettext('Colorado') },
            { region: 'CT', country: 'US', name: gettext('Connecticut') },
            { region: 'DE', country: 'US', name: gettext('Delaware') },
            { region: 'DC', country: 'US', name: gettext('District of Columbia') },
            { region: 'FL', country: 'US', name: gettext('Florida') },
            { region: 'GA', country: 'US', name: gettext('Georgia') },
            { region: 'HI', country: 'US', name: gettext('Hawaii') },
            { region: 'ID', country: 'US', name: gettext('Idaho') },
            { region: 'IL', country: 'US', name: gettext('Illinois') },
            { region: 'IN', country: 'US', name: gettext('Indiana') },
            { region: 'IA', country: 'US', name: gettext('Iowa') },
            { region: 'KS', country: 'US', name: gettext('Kansas') },
            { region: 'KY', country: 'US', name: gettext('Kentucky') },
            { region: 'LA', country: 'US', name: gettext('Louisiana') },
            { region: 'ME', country: 'US', name: gettext('Maine') },
            { region: 'MD', country: 'US', name: gettext('Maryland') },
            { region: 'MA', country: 'US', name: gettext('Massachusetts') },
            { region: 'MI', country: 'US', name: gettext('Michigan') },
            { region: 'MN', country: 'US', name: gettext('Minnesota') },
            { region: 'MS', country: 'US', name: gettext('Mississippi') },
            { region: 'MO', country: 'US', name: gettext('Missouri') },
            { region: 'MT', country: 'US', name: gettext('Montana') },
            { region: 'NE', country: 'US', name: gettext('Nebraska') },
            { region: 'NV', country: 'US', name: gettext('Nevada') },
            { region: 'NH', country: 'US', name: gettext('New Hampshire') },
            { region: 'NJ', country: 'US', name: gettext('New Jersey') },
            { region: 'NM', country: 'US', name: gettext('New Mexico') },
            { region: 'NY', country: 'US', name: gettext('New York') },
            { region: 'NC', country: 'US', name: gettext('North Carolina') },
            { region: 'ND', country: 'US', name: gettext('North Dakota') },
            { region: 'OH', country: 'US', name: gettext('Ohio') },
            { region: 'OK', country: 'US', name: gettext('Oklahoma') },
            { region: 'OR', country: 'US', name: gettext('Oregon') },
            { region: 'PA', country: 'US', name: gettext('Pennsylvania') },
            { region: 'RI', country: 'US', name: gettext('Rhode Island') },
            { region: 'SC', country: 'US', name: gettext('South Carolina') },
            { region: 'SD', country: 'US', name: gettext('South Dakota') },
            { region: 'TN', country: 'US', name: gettext('Tennessee') },
            { region: 'TX', country: 'US', name: gettext('Texas') },
            { region: 'UT', country: 'US', name: gettext('Utah') },
            { region: 'VT', country: 'US', name: gettext('Vermont') },
            { region: 'VA', country: 'US', name: gettext('Virginia') },
            { region: 'WA', country: 'US', name: gettext('Washington') },
            { region: 'WV', country: 'US', name: gettext('West Virginia') },
            { region: 'WI', country: 'US', name: gettext('Wisconsin') },
            { region: 'WY', country: 'US', name: gettext('Wyoming') }
        ])
        .constant('welcomeKitUrl', 'pdf/DigitalWelcomeBook2020-{0}.pdf')
        .constant('selectProvinceCaption', 'Select your province')
        .constant('selectStateCaption', 'Select your state')
        .constant('defaultClubLogoUrl', '/images/default_club_logo.png')
        .constant('defaultCourseLogoUrl', '/images/default_club_logo.png')
        .constant('classicViewTokenParam', 'logintoken')
        .constant('genusTokenParam', 'token')
        .constant('defaultPageSizes', [10, 25, 50, 100])
        .enumeration('clubMembershipLevelType', {
            Default: [, gettext('Default')],
            Bronze: [, gettext('Bronze')],
            Silver: [, gettext('Silver')],
            Gold: [, gettext('Gold')]
        })
        .enumeration('gender', {
            Male: [, gettext('Male'), 'M'],
            Female: [, gettext('Female'), 'F']
        })       

        .enumeration('facilityType', {
            Public: [, gettext('Public')],
            SemiPublic: [, gettext('Semi-Public')],
            Private: [, gettext('Private')]
        })       

        //.constant('renewRedirectUrl', 'https://ecomm.golfcanada.ca/renew')
        .constant('renewRedirectUrl', 'https://ecomm.golfcanada.ca')
        .constant('geniusRedirectUrl', 'https://www.golfgenius.com/sso_gg')

        .constant('renewConfirmationDateStorageKey', 'renewConfirmationDate')

        .enumeration('alertType', {
            Error: 'Error',
            Warn: 'Warn',
            Info: 'Info',
            Success: 'Success'
        })
        .constant('shared_resources', {
            memberLookupPlaceholder: gettext('Enter "last, first name" or card #.'),
            ngnTokenRequestFailed: gettext('Failed to retrieve NGN token.'),
            encryptIdRequestFailed: gettext('Failed to encrypt id.'),
            courseListRequestFailed: gettext('Failed to retrieve course list from server.'),
            postScoreError: gettext('Failed to save score.'),
            postNoScoreError: gettext('Failed to save reason for not posting score.'),

            saveSettingsSucceeded: gettext('Your settings have been updated.'),
            saveSettingsFailed: gettext('Failed to save settings.'),
            requestCardSucceeded: gettext('Thank you, your new membership card should arrive in 2-3 weeks.'),
            requestCardFailed: gettext('Request for membership card failed.'),


            cancelSubscriptionSucceeded: gettext('Your auto-renewal has been canceled'),
            cancelSubscriptionFailed: gettext('Failed to cancel your auto-renewal.  Please contact customer support.'),

            emailSuccess: gettext('Email has been sent to {0}.'),
            emailFailed: gettext('Failed to send email to {0}.'),

            transferListRequestFailed: gettext('Failed to retrieve transfer list from server.'),
            confirmAcceptTransfer: gettext('Are you sure you want to accept {0}?'),
            acceptTransferFailed: gettext('Failed to accept {0}.'),
            confirmRejectTransfer: gettext('Are you sure you want to reject {0}?'),
            rejectTransferFailed: gettext('Failed to reject {0}.'),

            changePasswordSucceeded: gettext('Your password has been updated.'),
            changePasswordFailed: gettext('Failed to update password.'),
            contactGolfClubMessage: gettext('Please contact your club to have your membership renewed.'),
            lowScoreWarningConfirmation: gettext('The score entered is below your expected scoring range.  Please confirm that the score information and number of holes played is accurate before posting this score.\n\n\rDo you want to continue to post this score?')
        })
        .enumeration('formatPlayed', {
            StrokePlay: [, gettext('Stroke Play')],
            MatchPlay: [, gettext('Match Play')],
            Other: [, gettext('Other')]
        })
        .enumeration('holesPlayed', {
            EighteenHoles: [, gettext('18 Holes')],
            FrontNine: [, gettext('Front 9')],
            BackNine: [, gettext('Back 9')]
        })
        .enumeration('holeType', {
            EighteenHoles: [, gettext('18 Holes')],
            NineHoles: [, gettext('9 Holes')],
            Both: [, gettext('Both 18 and 9 Holes')]
        })
        .enumeration('scoreAdjustmentType', {
            ExceptionalScore: [, gettext('Exceptional Score')],
            PCC: [, gettext('PCC')],
            Committee: [, gettext('Handicap Committee')]
        })
        .enumeration('courseStatus', {
            Active: 'Active',
            ActiveNonAssoc: 'ActiveNonAssoc',
            Inactive: 'Inactive',
            Archived: 'Archived'
        })
        .enumeration('clubMembershipStatus', {
            Inactive: { value: 'Inactive', displayName: 'Inactive', class: 'fa fa-user text-lightgrey' },
            Active: { value: 'Active', displayName: 'Active', class: 'fa fa-user text-green' },
            Pending: { value: 'Pending', displayName: 'Pending', class: 'fa fa-user text-lightgrey' },
            Archived: { value: 'Archived', displayName: 'Archived', class: 'fa fa-user-times text-lightgrey' }
        })
        .enumeration('clubMembershipTransferStatusType', {
            Pending: [, gettext('Pending')],
            Accepted: [, gettext('Accepted')],
            Rejected: [, gettext('Rejected')],
            TransferError: [, gettext('Error')]
        })
        .enumeration('equipmentClubType', {
            Driver: { value: 'Driver', displayName: gettext('Driver'), shortName: 'DR' },
            TwoWood: { value: 'TwoWood', displayName: gettext('2 Wood'), shortName: '2W' },
            ThreeWood: { value: 'ThreeWood', displayName: gettext('3 Wood'), shortName: '3W' },
            FourWood: { value: 'FourWood', displayName: gettext('4 Wood'), shortName: '4W' },
            FiveWood: { value: 'FiveWood', displayName: gettext('5 Wood'), shortName: '5W' },
            SixWood: { value: 'SixWood', displayName: gettext('6 Wood'), shortName: '6W' },
            SevenWood: { value: 'SevenWood', displayName: gettext('7 Wood'), shortName: '7W' },
            EightWood: { value: 'EightWood', displayName: gettext('8 Wood'), shortName: '8W' },
            NineWood: { value: 'NineWood', displayName: gettext('9 Wood'), shortName: '9W' },
            OneHybrid: { value: 'OneHybrid', displayName: gettext('1 Hybrid'), shortName: '1H' },
            TwoHybrid: { value: 'TwoHybrid', displayName: gettext('2 Hybrid'), shortName: '2H' },
            ThreeHybrid: { value: 'ThreeHybrid', displayName: gettext('3 Hybrid'), shortName: '3H' },
            FourHybrid: { value: 'FourHybrid', displayName: gettext('4 Hybrid'), shortName: '4H' },
            FiveHybrid: { value: 'FiveHybrid', displayName: gettext('5 Hybrid'), shortName: '5H' },
            SixHybrid: { value: 'SixHybrid', displayName: gettext('6 Hybrid'), shortName: '6H' },
            SevenHybrid: { value: 'SevenHybrid', displayName: gettext('7 Hybrid'), shortName: '7H' },
            EightHybrid: { value: 'EightHybrid', displayName: gettext('8 Hybrid'), shortName: '8H' },
            NineHybrid: { value: 'NineHybrid', displayName: gettext('9 Hybrid'), shortName: '9H' },
            OneIron: { value: 'OneIron', displayName: gettext('1 Iron'), shortName: '1I' },
            TwoIron: { value: 'TwoIron', displayName: gettext('2 Iron'), shortName: '2I' },
            ThreeIron: { value: 'ThreeIron', displayName: gettext('3 Iron'), shortName: '3I' },
            FourIron: { value: 'FourIron', displayName: gettext('4 Iron'), shortName: '4I' },
            FiveIron: { value: 'FiveIron', displayName: gettext('5 Iron'), shortName: '5I' },
            SixIron: { value: 'SixIron', displayName: gettext('6 Iron'), shortName: '6I' },
            SevenIron: { value: 'SevenIron', displayName: gettext('7 Iron'), shortName: '7I' },
            EightIron: { value: 'EightIron', displayName: gettext('8 Iron'), shortName: '8I' },
            NineIron: { value: 'NineIron', displayName: gettext('9 Iron'), shortName: '9I' },
            PitchingWedge: { value: 'PitchingWedge', displayName: gettext('Pitching Wedge'), shortName: 'PW' },
            GapWedge: { value: 'GapWedge', displayName: gettext('Gap Wedge'), shortName: 'GW' },
            SandWedge: { value: 'SandWedge', displayName: gettext('Sand Wedge'), shortName: 'SW' },
            LobWedge: { value: 'LobWedge', displayName: gettext('Lob Wedge'), shortName: 'LW' },
            Putter: { value: 'Putter', displayName: gettext('Putter'), shortName: 'PT' },
            Wood: { value: 'Wood', displayName: gettext('Wood'), shortName: 'WD' },
            Hybrid: { value: 'Hybrid', displayName: gettext('Hybrid'), shortName: 'HY' },
            Iron: { value: 'Iron', displayName: gettext('Iron'), shortName: 'IR' },
            Wedge: { value: 'Wedge', displayName: gettext('Wedge'), shortName: 'WG' }
        })
        .enumeration('fairwayHitType', {
            Hit: { displayName: gettext('Hit'), shortName: 'HIT' },
            MissedShort: { displayName: gettext('Short'), shortName: 'SRT' },
            MissedLong: { displayName: gettext('Long'), shortName: 'LNG' },
            MissedLeft: { displayName: gettext('Left'), shortName: 'LFT' },
            MissedRight: { displayName: gettext('Right'), shortName: 'RHT' },
            MissedUnspecified: { displayName: gettext('Miss'), shortName: 'MIS' },
            NoOpportunity: { displayName: gettext('N/A'), shortName: 'N/A' },
        })
        .enumeration('scorePostingMethod', {
            Total: [, gettext('Total')],
            HoleByHole: [, gettext('Hole By Hole')],
            Statistics: [, gettext('Statistics')]
        })
        .constant('defaultTransferListPageSize', 10)
        .constant('transferLookupPlaceholder', gettext('Enter "last, first name" or card #.'))

        .enumeration('reasonForNotPostingType', {
            Scramble: [, gettext('Played a Scramble')],
            FoursomeFormat: [, gettext('Played a foursome format (alternate shot)')],
            Weather: [, gettext('Rained Out / Weather issues')],
            LessThanSevenHoles: [, gettext('Played less than 7 holes')],
            NotEnoughClubs: [, gettext('Played an event limiting the number of clubs to less than 14')],
            PlayedAlone: [, gettext('Played Alone')],
            PracticeRound: [, gettext('Played a practice round (more than one ball in play)')],
            NonConventionalClubs: [, gettext('Played with non-conforming clubs')],
            Other: [, gettext('Other')]
        });

})();
